import { Dialog, Divider, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { ChangeEvent, useState } from 'react';
import styles from './styles';

interface IFilterProps {
    id?: string;
    modalContent?: React.ReactNode;
    searchChange?: (text: string) => void;
    onFiltersClearClick?: () => void;
    onApplyFiltersClick?: () => void;
    placeholder?: string;
    disabled?: boolean;
}

export default function Filter({
    modalContent,
    searchChange,
    id,
    onApplyFiltersClick,
    onFiltersClearClick,
    placeholder,
    disabled = false,
}: IFilterProps) {
    const [value, setValue] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);
    const onClose = () => {
        setOpen(false);
    };
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value;
        setValue(val);
        if (searchChange) {
            searchChange(val);
        }
    };
    const onFilterButtonClick = () => {
        setOpen(!open);
    };
    const onFilterClearButtonClick = () => {
        if (onFiltersClearClick) {
            onFiltersClearClick();
            setOpen(!open);
        }
    };
    const onFilterApplyButtonClick = () => {
        if (onApplyFiltersClick) {
            onApplyFiltersClick();
            setOpen(!open);
        }
    };
    return (
        <>
            <Typography component="div" sx={styles.root}>
                <Typography component="div">
                    <TextField
                        id={id}
                        name="filter"
                        placeholder={placeholder}
                        type="text"
                        variant="outlined"
                        size="small"
                        onChange={onChange}
                        value={value}
                        sx={styles.autoComplete}
                        InputProps={{
                            endAdornment: value && (
                                <IconButton
                                    id="clear-icon-btn"
                                    aria-label="toggle password visibility"
                                    onClick={() => {
                                        setValue('');
                                        if (searchChange) {
                                            searchChange('');
                                        }
                                    }}
                                >
                                    <img id="img-clear" src="/images/search-clear.svg" alt="close" />
                                </IconButton>
                            ),
                        }}
                        disabled={disabled}
                    />
                    <Dialog
                        id="filter-dialog"
                        onClose={onClose}
                        PaperProps={{ sx: styles.paperProps }}
                        hideBackdrop
                        open={open}
                    >
                        {modalContent}
                        <Divider />
                        <Typography component="div" sx={styles.buttonLayout}>
                            <div>
                                <Button
                                    id="filter-clear"
                                    onClick={onFilterClearButtonClick}
                                    sx={styles.filterButtons}
                                    color="primary"
                                    variant="text"
                                >
                                    Clear Filters
                                </Button>
                            </div>
                            <div>
                                <Button
                                    id="filter-apply"
                                    onClick={onFilterApplyButtonClick}
                                    sx={styles.filterButtons}
                                    color="primary"
                                    variant="contained"
                                >
                                    Apply Filters
                                </Button>
                            </div>
                        </Typography>
                    </Dialog>
                </Typography>
                <Typography component="div">
                    <Button
                        id="filter-open-button"
                        onClick={onFilterButtonClick}
                        variant="outlined"
                        sx={styles.button}
                        disabled={disabled}
                    >
                        <img src="/images/filters.svg" alt="filter" />
                    </Button>
                </Typography>
            </Typography>
        </>
    );
}
